import { useState, useEffect, useCallback } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function useVideo(id) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  async function fetchVideo() {
    setLoading(true);
    const { response, data } = await API.fetchVideo(token, id);

    if (response.ok) {
      setResult(data);
      setLoading(false);
      setError(null);
    } else {
      setError({ status: response.status, ...data });
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchVideo();
  }, [id]);

  const refresh = useCallback(() => fetchVideo(), [id]);

  return {
    loading,
    error,
    refresh,
    video: result,
  };
}
